<div *ngIf="event">
  <div class="card mb-3">
    <img [src]="image()" class="card-img img-fluid" [alt]="event.title" [title]="event.title" />
  </div>
</div>
